<ui-object-navigation-main-page alias="im"></ui-object-navigation-main-page>